import { useEffect, useState } from 'react';

// Below this width there isn't room to dock a panel beside the page content,
// so the sidebar becomes a modal sheet instead.
export const sidebarDialogQuery = '(max-width: 799px)';

export type SidebarPresentation = 'dialog' | 'docked';

// Hosts that reflow their own layout around a docked sidebar can call this to
// stay in step with the presentation the sidebar picks.
export const useSidebarPresentation = (): SidebarPresentation => {
  const [isDialog, setIsDialog] = useState(
    () => window.matchMedia(sidebarDialogQuery).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(sidebarDialogQuery);
    const handleChange = (event: MediaQueryListEvent) => {
      setIsDialog(event.matches);
    };

    setIsDialog(mediaQuery.matches);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  return isDialog ? 'dialog' : 'docked';
};
